// extracted by mini-css-extract-plugin
export default {"nav_flex":"NavbarHome_nav_flex__CD+h-","links_flex":"NavbarHome_links_flex__htk9+","cred_links":"NavbarHome_cred_links__011UU"};